import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { NotFoundPageComponent } from "./not-found-page.component";

const materialModules = [MatCardModule, MatButtonModule];

@NgModule({
  declarations: [NotFoundPageComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, BrowserAnimationsModule, ...materialModules],
})
export class NotFoundPageModule {}
